import { Select, type SelectProps, Spin } from 'antd';

import { useGetRatios } from '@/hooks';

import withAutoSelectSingleOption from '../withAutoSelectSingleOption';

const AutoSelect = withAutoSelectSingleOption(Select);

type Props = Omit<SelectProps, 'options' | 'loading'> & {
  regionId?: string;
  cycleId?: string;
  excludeConfigured?: boolean;
  autoSelectEnabled?: boolean;
};

const RatioSelect = ({
  placeholder,
  regionId,
  cycleId,
  disabled,
  excludeConfigured,
  allowClear = true,
  ...restProps
}: Props) => {
  const { options: ratiosOptions, isLoading: ratiosLoading } = useGetRatios({
    regionId,
    cycleId,
    excludeConfigured
  });
  const isDisabled = disabled || ratiosLoading || ratiosOptions.length === 0;

  return (
    <AutoSelect
      options={ratiosOptions}
      placeholder={placeholder ?? 'Select a ratio'}
      loading={ratiosLoading}
      disabled={isDisabled}
      notFoundContent={ratiosLoading ? <Spin size='small' /> : null}
      allowClear={allowClear}
      {...restProps}
    />
  );
};

export default RatioSelect;
